import { Box, Typography } from "@mui/material";
import { memo } from "react";

import type { InstagramFeatureItemProps } from "./InstagramFeatureItem.types";
import * as styles from "./InstagramFeatureItem.styles";

export type { InstagramFeatureItemProps } from "./InstagramFeatureItem.types";

export const InstagramFeatureItem = memo(function InstagramFeatureItem({
  icon: FeatureIcon,
  title,
  description,
}: InstagramFeatureItemProps) {
  return (
    <Box sx={styles.root}>
      <Box sx={styles.iconTile}>
        <FeatureIcon size={21} variant="Bulk" color="currentColor" />
      </Box>
      <Box sx={styles.text}>
        <Typography sx={styles.title}>{title}</Typography>
        <Typography sx={styles.description}>{description}</Typography>
      </Box>
    </Box>
  );
});
